var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimizedLandingPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-find-in-page",
    "data-name": "Icon material-find-in-page",
    d: "M30,29.385V12L21,3H9A3,3,0,0,0,6.015,6L6,30a3,3,0,0,0,2.985,3H27a2.973,2.973,0,0,0,1.785-.6L22.14,25.755A7.5,7.5,0,1,1,25.5,19.5a7.468,7.468,0,0,1-1.245,4.125ZM13.5,19.5A4.5,4.5,0,1,0,18,15,4.494,4.494,0,0,0,13.5,19.5Z",
    transform: "translate(-6 -3)",
    fill: "#329998"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizedLandingPage);
export default __webpack_public_path__ + "static/media/optimizedLandingPage.929c98f6.svg";
export { ForwardRef as ReactComponent };